export default {
    title1: "訂單狀態",
    title2: "支付狀態",
    title3: "我的商品",
    status1: "未審批",
    status2: "已審批",
    status3: "全單取消",
    status4: "申請修改",
    status5: "已確認收貨",
    status6: "已付款",
    status7: "未付款",
    status8: "申請退貨",
	status9: "全部訂單",
	status10: "待支付",
	status11: "已全數支付",
	status12: "已部分支付",
    more: "查看更多",
    // top
    welc: "歡迎您",
 //    surplus: "金額使用餘額：",
	// surplus2: "現有餘額：",
	// surplus3: "月度累計金額：",
	// surplus4: "年度餘額：",
	surplus: "金額使用餘額：",
	surplus2: "全年總額：",
	surplus3: "當月金額：",
	surplus4: "累計年初至上月：",
	surplus5: "累計年初至當月：",
    level: "優惠等級：",
    score: "積分：",
    company: "公司名稱：",
    truename: "真實姓名：",
    email: "E-mail：",
    uid: "用戶ID：",
    createtime: "註冊時間：",
    cart: "購物車",
    collection: "我的收藏",
    qcart: "報價車",
    ordernum: "訂單數",
	ordermine:"子賬戶訂單數"
}